import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e92c45b"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-line",
  style: {
    "margin-top": "10px"
  }
}, "订阅组可理解为将订阅商品分组，同一服务内容，但订阅时长不一样的订阅商品可放同一组；（如VIP月会员和VIP年会员）", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-line"
}, " 不同服务内容的订阅商品可放在不同订阅组；（如VIP月会员和超级VIP月会员） ", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-line"
}, " 对于每个订阅群组，用户同一时间只能购买其中的一个订阅产品。 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-line"
}, " 因此，只创建一个订阅组可以避免用户不小心购买多个订阅产品。 ", -1));
const _hoisted_5 = {
  style: {
    "color": "rgba(0, 0, 0, 0.65)"
  }
};
const _hoisted_6 = {
  style: {
    "margin-top": "12px",
    "color": "rgba(0, 0, 0, 0.65)",
    "margin-bottom": "18px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-tip",
  style: {
    "margin-bottom": "48px"
  }
}, " *该名称会在用户App Store账户-订阅项目中展示，请勿随意填写 ", -1));
const _hoisted_8 = {
  style: {
    "text-align": "right"
  }
};
import { message } from 'ant-design-vue';
import { createSubscriptionGroup } from "@/api/goodsInfo";
import { queryLangOption } from '@/api/goodsSetting';
export default /*#__PURE__*/_defineComponent({
  __name: 'dyzModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    dbtId: null,
    prodChnl: null
  },
  emits: ['update:modalVisible', 'updateList'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const inputValue = ref('');
    const lang = ref([]);
    const langOptions = ref([]);
    const loading = ref(false);
    const closeModal = () => {
      emit('update:modalVisible', false);
    }; // 关闭弹窗
    const addClick = async () => {
      if (inputValue.value.trim() === '') {
        message.error('请输入订阅组名称');
        return;
      }
      try {
        loading.value = true;
        const res = await createSubscriptionGroup({
          dbtId: props.dbtId,
          groupName: inputValue.value,
          groupNameLocals: [{
            name: lang.value.label,
            locale: lang.value.value
          }]
        });
        if (res.code === '0') {
          message.success('创建成功');
          closeModal();
          emit('updateList');
        }
      } finally {
        loading.value = false;
      }
    }; // 创建
    const openModal = () => {
      inputValue.value = '';
      lang.value = [];
      getLang();
    }; // 打开弹窗
    const getLang = async () => {
      const res = await queryLangOption({
        prodChnl: props.prodChnl
      });
      if (res.code === '0') {
        langOptions.value = res.data;
      }
    }; // 获取语言
    expose({
      openModal
    });
    // onMounted(async () => {
    //   try {
    //     const res = await queryLangOption({
    //       prodChnl: props.prodChnl
    //     })
    //     if(res.code === '0') {
    //       langOptions.value = res.data
    //     }
    //   } catch (error) {
    //     console.log('语言获取失败', error)
    //   }
    // })
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        title: "新增订阅组",
        bodyStyle: {
          padding: '16px'
        },
        width: "822px",
        onCancel: closeModal,
        centered: "",
        footer: false
      }, {
        default: _withCtx(() => [_hoisted_1, _hoisted_2, _hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createTextVNode(" 订阅组语言： "), _createVNode(_component_a_select, {
          class: "selecter",
          style: {
            "width": "200px"
          },
          value: lang.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => lang.value = $event),
          options: langOptions.value,
          placholder: "请选择语言",
          "field-names": {
            label: 'langName',
            value: 'lang'
          },
          "show-search": "",
          labelInValue: ""
        }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_6, [_createTextVNode(" 订阅组名称： "), _createVNode(_component_a_input, {
          style: {
            "width": "88%"
          },
          value: inputValue.value,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => inputValue.value = $event)
        }, null, 8, ["value"])]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_a_button, {
          style: {
            "margin-right": "8px"
          },
          onClick: closeModal
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          onClick: addClick,
          loading: loading.value
        }, {
          default: _withCtx(() => [_createTextVNode("创建")]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});